<template>
  <div>
    <PageAllow controller="PositionMoves" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('MovePositionOrder.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">
                {{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}
              </v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="$permission.permissionAllow('PositionMoves', 'add')"
              small
              color="primary"
              href="/#/move-position-order/auto-move"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{
                $t("CRUD.newInfo", [
                  $t("MovePositionOrder.autoMovePositionOrder"),
                ])
              }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('PositionMoves', 'add')"
              small
              color="primary"
              href="/#/move-position-order/new"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.newInfo", [$t("MovePositionOrder.ObjectName")]) }}
            </v-btn>
            <!-- TODO：移库单导出，缺接口 -->
            <v-btn
              small
              color="print"
              dark
              class="ms-1"
              v-if="$permission.permissionAllow('PositionMoves', 'export')"
            >
              <v-icon x-small class="pe-1">fa-file-export</v-icon>
              {{ $t("Export.export", [$t("MovePositionOrder.ObjectName")]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="move_order_code"
                  v-model="options.move_order_code"
                  @text="movePositionCodeKeyword = $event"
                  :label="$t('MovePositionOrder.movePositionOrderCodeSearch')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="move_order_code"
                  v-model="options.move_order_code"
                  @text="movePositionCodeKeyword = $event"
                  :label="$t('MovePositionOrder.movePositionOrderCodeSearch')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="options.type"
                  :label="$t('MovePositionOrder.type.title')"
                  :items="$consts.movePositionOrder.type"
                  item-text="text"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStock
                  v-model="stocksSelected"
                  :stockTypes="[0]"
                  :wmsSetting="[1]"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="moveOrders"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.type="{ item }">
            {{ item.type | movePositionOrderWaysText }}
          </template>
          <template v-slot:item.operation_type="{ item, index }">
            <span
              v-if="item.type == 1"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.operation_type | movePositionOrderTypesText }}
            </span>
          </template>
          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
          <template v-slot:item.delete_flg="{ item }">
            <v-chip
              small
              label
              :color="item.delete_flg | movePositionOrderCancelFlgsColor"
              :text-color="
                item.delete_flg | movePositionOrderCancelFlgsTextColor
              "
              >{{ item.delete_flg | movePositionOrderCancelFlgsText }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <MovePositionOrderActions
              :move_position_order="item"
              showView
              :showEdit="item.actions.edit"
              :showShelveOn="item.actions.shelve_on"
              :showShelveOff="item.actions.shelve_off"
              :showCancel="item.actions.cancel"
              @done="getMoveOrdersFromAPI()"
              @packConfirm="completePackConfirm($event)"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import MovePositionOrders from "@/api/move_position_orders";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import MovePositionOrderActions from "./plugins/Actions";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  move_order_code: "",
  stock_ids: [],
  type: [],
  cancel_flgs: [0],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherKeyword,
    SearcherStock,
    SearcherCancelFlgs,
    MovePositionOrderActions,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.movePositionOrder"),
          disabled: true,
          href: "/move-position-order",
        },
      ];
    },

    headers() {
      return [
        {
          text: i18n.t("MovePositionOrder.Fields.move_position_order_code"),
          align: "start",
          sortable: false,
          value: "move_order_code",
        },
        {
          text: i18n.t("MovePositionOrder.Fields.stock_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "stock.name",
        },
        {
          text: i18n.t("MovePositionOrder.Fields.move_position_order_way"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "type",
        },
        {
          text: i18n.t("MovePositionOrder.Fields.move_position_order_type"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "operation_type",
        },
        {
          text: i18n.t("MovePositionOrder.Fields.created_time"),
          align: "center",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("MovePositionOrder.Fields.operater_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "operater.name",
        },
        {
          text: i18n.t("TableHeaders.status"),
          align: "start",
          sortable: false,
          value: "delete_flg",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "stickTableCols"]),
  },

  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    movePositionCodeKeyword: "",
    stocksSelected: null,
    options: JSON.parse(
      sessionStorage.getItem("move-position-orders-options")
        ? sessionStorage.getItem("move-position-orders-options")
        : JSON.stringify(defaultOptions)
    ),
    moveOrders: [],
    paging: {},
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("move-position-orders", ["stocksSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.stocksSelected = null;
      this.datetimeRage = [
        new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.move_order_code].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        move_order_code: this.movePositionCodeKeyword,
      });
    },
    getMoveOrdersFromAPI() {
      MovePositionOrders.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.moveOrders = response.data.move_orders;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getMoveOrdersFromAPI();
        sessionStorage.setItem(
          "move-position-orders-options",
          JSON.stringify(this.options)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.id
          : "";
        sessionStorage.setItem(
          "move-position-orders-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
  },
};
</script>